import Vue from 'vue'
import Router from 'vue-router'

import appRouter from './app'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    appRouter
  ]
})
